import { render, staticRenderFns } from "./request-list.vue?vue&type=template&id=c78fc1c0&scoped=true"
import script from "./request-list.vue?vue&type=script&lang=js"
export * from "./request-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78fc1c0",
  null
  
)

export default component.exports